// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1gYQt","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__OFf66"};